import { StateOfGoods } from "@freightsimple/generated-dashboard-openapi-client/models/StateOfGoods";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { SegmentControl } from "@freightsimple/ui-core/Controls/SegmentControl";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { NewIcon, StateOfGoodsIcons } from "@/Shared/Icons/StateOfGoodsIcons";

interface StateOfGoodsSelectorProps {
  stateOfGoods: StateOfGoods | undefined;
  onStateOfGoodsChange: (newValue: StateOfGoods) => void;
  disabled: boolean;
  forceValidation: boolean;
  errorMessage?: ErrorMessageType | undefined;
}

// Bespoke SVGs rather than Phosphor, so they ride in as startContent (which
// takes any node) instead of the `icon` slot (which sizes a Phosphor icon).
const options = [
  { id: StateOfGoods.New, label: "New", startContent: <NewIcon /> },
  { id: StateOfGoods.Used, label: "Used", startContent: <StateOfGoodsIcons /> },
];

export function BookShipmentStateOfGoodsSelector(
  props: StateOfGoodsSelectorProps,
) {
  return (
    <ShowFormErrors show={props.forceValidation}>
      <FormItem error={props.errorMessage}>
        <SegmentControl
          options={options}
          active={props.stateOfGoods ?? ""}
          onChange={(id) => props.onStateOfGoodsChange(id as StateOfGoods)}
          disabled={props.disabled}
        />
      </FormItem>
    </ShowFormErrors>
  );
}
